export const resData = (
  data: { [key: string]: any } | null,
  defValue = {},
): { [key: string]: any } | undefined => {
  if (data) {
    return data.code == 0 ? data.result || defValue : undefined;
  } else {
    return undefined;
  }
};
